import apiClient from '../apiClient';
import { UPLOAD_PREVIEW_RESTAURANT_PROFILE_URL } from '../apiUrl';

const uploadMasterDataPreviewRestaurantProfileApi = data => {
  return apiClient.post(UPLOAD_PREVIEW_RESTAURANT_PROFILE_URL, data);
};

export default uploadMasterDataPreviewRestaurantProfileApi;
